import { getOrganisationId } from 'utils/organisation'
import { REACT_APP_API_MEDIA_URL } from './constants/mediaPaths'

export const generateMediaPath = (filepath: string, fileType = 'images') => {
  const organisationId = getOrganisationId()
  return `${REACT_APP_API_MEDIA_URL}/${organisationId}-${fileType}/${filepath}`
}
